import React from 'react';
import { useSelector } from 'react-redux';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const WhsManagementGridActions = (navigateToWithholdingStatement, navigateToImyStructure, navigateToForm) => {
  const permissions = useSelector(state => state.auth.permissions);
  const settings = useSelector(state => state.auth.settings);

  return ({
    id: 'action-column',
    Header: <span>Action</span>,
    Cell: ({ row }) => (
      <div>
        <div className="form-action-btn-group">
          { AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree])
            && row.original.accountId && row.original.formIsValid === 'N/A'
          && <button
            className="btn btn-sm"
            id={ 'btn-navToImy_'.concat(row.original.accountId) }
            type="button"
            title="Show IMY Tree Structure"
            onClick={ () => navigateToImyStructure(row.original.accountId, row.original.version) }
          ><span className="icon icon-treeview" /></button> }
          { AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrViewWhs])
          && (settings && settings.showMultiTierManager)
              && row.original.accountId && row.original.formIsValid === 'N/A'
          && <button
            className="btn btn-sm icon-whd-stmt"
            id={ 'btn-navToWhs_'.concat(row.original.accountId) }
            type="button"
            title="View Digital Withholding Statement"
            onClick={ () => navigateToWithholdingStatement(row.original.accountId, row.original.version) }
          >WHS</button> }
          {AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
            && (settings && settings.showMultiTierManager)
            && row.original.accountId && row.original.formIsValid !== 'N/A'
            && <button
              className="whs-grid-form-button"
              type="button"
              title="Form"
              onClick={ () => navigateToForm(row.original.accountId, row.original.formId, row.original.formType) }
            >
              <span className="icon icon-apps" />
            </button>}
        </div>
      </div>
    ),
    className: 'col-5p'
  });
};

export default WhsManagementGridActions;
